import { ItemType } from '../../../constants/ItemType';
import { MainSource } from '../../../constants/Source';
import { SystemFolderId } from '../../../constants/SystemFolderId';

export const fakeDataResponse = (data: any) => ({
  status: 200,
  statusText: 'OK',
  responseSize: 1,
  data,
});

export const wixVideoLibraryLink = [
  {
    id: SystemFolderId.WixVideoLink,
    kind: ItemType.Folder,
    source: MainSource.SiteFiles,
    name: 'Video Library',
    parentId: null,
    siteId: null,
  },
];
